import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private fs:AngularFirestore) { }

  confirmOrder(
    name:string,
    email?:string,
    message?:string
  )
{
return new Promise((resolve, reject)=> {
    this.fs.collection('contact').add({
      name,
      email,
      message
    }).then(()=>resolve())
  })
}
}
